import React, { useState, useEffect } from 'react';
import { Modal, Button, Table, Form, Card } from 'react-bootstrap';
import { FaPrint, FaEye, FaDownload, FaHistory, FaFilePdf, FaFileExcel, FaFileImage, FaInfoCircle } from 'react-icons/fa';
import HomeService from '../services/HomeService';
import { useLoading } from '../Utils/LoadingContext';
import { toast } from 'react-toastify';
import ApprovalProcessService from '../services/ApprovalProcessService';
import PaginationComponent from '../Utils/PaginationComponent';
import ExcelPreviewModal from '../Utils/PreviewModal';
import logo from '../assets/logo.png';
import './StatusReport.css';
import AsyncSelect from 'react-select/async';
import showToast from "../Utils/ToastContainer";
import ActionExcelPreviewModal from '../Utils/PreviewModal';

const StatusReport = () => {
    const departmentName = localStorage.getItem('departmentName') || "Department";
    const { setLoading } = useLoading();
    const [reportData, setReportData] = useState([]);
    const [selectedDescription, setSelectedDescription] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [showHistoryModal, setShowHistoryModal] = useState(false);
    const [filters, setFilters] = useState({ lcnumber: '', status: '1', subjectTitle: '', lcApproval: '', requestedBy: '' });
    const [historyData, setHistoryData] = useState([]);
    const [historyItem, setHistoryItem] = useState(null);
    const [statusType, setstatusType] = useState([]);
    const [excelshowModal, setexcelShowModal] = useState(false);
    const [excelData, setExcelData] = useState([]);
    const [fileName, setFileName] = useState("");
    const [fileURL, setFileURL] = useState("");
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [selectedDetails, setSelectedDetails] = useState(null);
    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(5);
    const [totalRecords, setTotalRecords] = useState(0);
    const [approvalType, setapprovalType] = useState([]);
    const [selectedRequester, setSelectedRequester] = useState(null);
    const [actionexcelshowModal, setactionexcelShowModal] = useState(false);
    const [actionexcelData, setactionExcelData] = useState([]);
    const [actionfileName, setactionFileName] = useState("");
    const [actionfileURL, setactionFileURL] = useState("");


    const totalPages = Math.ceil(totalRecords / pageSize);
    const handlePreviewExcel = (data, name, url) => {
        const nameParts = name.split("_");
        const displayName = nameParts.length > 1 ? nameParts.slice(1).join("_") : name;
        setExcelData(data);
        setFileName(displayName);
        setFileURL(url);
        setexcelShowModal(true);
    };

    const handleActionPreviewExcel = (data, name, url) => {

        const nameParts = name.split("_");
        const displayName = nameParts.length > 1 ? nameParts.slice(1).join("_") : name;
        setactionExcelData(data || []);
        setactionFileName(displayName);
        setactionFileURL(url || "");
        setactionexcelShowModal(true);
    };

    const openDetailsModal = (item) => {
        setSelectedDetails(item);
        setShowDetailsModal(true);
    };

    const handleSendToBank = async (id) => {
        const confirmed = window.confirm("Are you sure you want to update the status of Send to Bank?");
        if (confirmed) {
            try {

                const response = await ApprovalProcessService.InsertSendToBankStatus(id);

                if (response.data.statusCode === 200) {
                    showToast("Your Request hab been successfully updated.", 'success', { autoClose: 700 });
                    const lc = filters.lcnumber.trim() === '' ? null : filters.lcnumber.trim();
                    const st = filters.status === '' ? 0 : parseInt(filters.status);
                    const lcApproval = filters.lcApproval === '' ? 0 : parseInt(filters.lcApproval);
                    const requestedBy = filters.requestedBy === '' ? 0 : parseInt(filters.requestedBy);
                    const subjectTitle = filters.subjectTitle.trim() === '' ? null : filters.subjectTitle.trim();
                    setCurrentPage(1); // Reset to first page
                    fetchData(1, pageSize, lc, st, subjectTitle, lcApproval, requestedBy);
                }
                // You may want to refresh the list or update state here
            } catch (error) {
                console.error("Error updating status:", error);
                alert("Failed to update status");
            }
        }
    };

    const requestedByOptions = async (inputValue) => {
        if (!inputValue || inputValue.trim() === "") return [];

        try {

            const response = await ApprovalProcessService.getApproverDropDownListData(inputValue);
            if (response.success) {
                return response.data.result.map(item => ({
                    value: item.id,
                    label: item.name,
                    id: item.id,
                    name: item.name
                }));
            }
        } catch (error) {
            console.error("Error loading approver options:", error);
        }
        return [];
    };


    const handlePrint = () => {

        // if (!selectedDetails) return;

        const contentToPrint = document.getElementById("printable-details").cloneNode(true);

        // Optional: hide print/close buttons if present
        const printButton = contentToPrint.querySelector("#btnPrint");
        if (printButton) {
            printButton.style.display = "none";
        }
        const closeButton = contentToPrint.querySelector("#btnClose");
        if (closeButton) {
            closeButton.style.display = "none";
        }

        const printWindow = window.open('', '', 'height=600,width=800');

        printWindow.document.write('<html><head><title>Print</title>');

        // Dynamically include all styles (Bootstrap + local)
        const styles = document.querySelectorAll("link[rel='stylesheet'], style");
        styles.forEach(style => {
            printWindow.document.write(style.outerHTML);
        });

        printWindow.document.write('</head><body>');
        printWindow.document.write(contentToPrint.innerHTML);
        printWindow.document.write('</body></html>');

        printWindow.document.close();
        printWindow.focus();
        printWindow.print(); // No delay
        printWindow.close();
    };

    const fetchData = async (page = 1, pageSize = 5, filterLc = null, filterStatus = 1,
        subjectTitle = null, lcApproval = 0, requestedBy = 0) => {
        setLoading(true);

        filterStatus = filters.status === '' ? 0 : parseInt(filters.status);
        lcApproval = filters.lcApproval === '' ? 0 : parseInt(filters.lcApproval);
        requestedBy = filters.requestedBy === '' ? 0 : parseInt(filters.requestedBy);
        subjectTitle = filters.subjectTitle.trim() === '' ? null : filters.subjectTitle.trim();
        try {
            const response = await HomeService.getstatusReport(filterLc, filterStatus, page, pageSize,
                subjectTitle, lcApproval, requestedBy);
            if (response?.success) {

                const mappedData = response.data.result.map((item) => ({
                    id: item.id,
                    companyName: item.companyName,
                    departmentName: item.departmentName,
                    approvalTypeName: item.lcType,
                    description: item.description,
                    lcnumber: item.lcNumber,
                    assignedBy: item.assignedBy,
                    attachmentFiles: item.attachmentFiles,
                    statusText: item.statusText,
                    actionOn: item.actionOn,
                    title: item.title,
                    approverNameList: item.approverNameList,
                    requestedOn: item.requestedOn,
                    approvalCommentsList: item.approvalCommentsList,
                    isSendToBank: item.isSendToBank
                }));

                setReportData(mappedData);
                // setTotalRecords(response.data.totalCount);
                setTotalRecords(response.data.result[0]?.totalCount || 0);
            } else {
                setReportData([]);
                setTotalRecords(0);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(currentPage, pageSize);

        const fetchStatusTypes = async () => {
            const statusTypeResponse = await ApprovalProcessService.getDropDownListData(4);
            const approvalTypeResponse = await ApprovalProcessService.getDropDownListData(2);
            if (approvalTypeResponse.success) setapprovalType(approvalTypeResponse.data.result);
            if (statusTypeResponse.success) {
                setstatusType(statusTypeResponse.data.result);
            }
        };

        fetchStatusTypes();
    }, [currentPage]);

    const handleFilter = () => {
        const lc = filters.lcnumber.trim() === '' ? null : filters.lcnumber.trim();
        const st = filters.status === '' ? 0 : parseInt(filters.status);
        const lcApproval = filters.lcApproval === '' ? 0 : parseInt(filters.lcApproval);
        const requestedBy = filters.requestedBy === '' ? 0 : parseInt(filters.requestedBy);
        const subjectTitle = filters.subjectTitle.trim() === '' ? null : filters.subjectTitle.trim();
        setCurrentPage(1); // Reset to first page
        fetchData(1, pageSize, lc, st, subjectTitle, lcApproval, requestedBy);
    };

    const openDescription = (desc) => {
        setSelectedDescription(desc);
        setShowModal(true);
    };

    const handleShowHistory = async (item) => {
        try {
            setLoading(true);
            const response = await HomeService.getApproverHistory(item.id);
            setHistoryData(response?.success ? response.data.result : []);
            setHistoryItem(item);
            setShowHistoryModal(true);
        } catch (error) {
            console.error("Error fetching history:", error);
            toast.error("Failed to load history.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container ">
            <div className="request-form">
                <h6 className="fw-bold text-primary mb-2">Status Report</h6>
                {/* Filter Section */}
                <Card className="mb-2 shadow-sm">
                    <Card.Body>
                        <div className="row g-3">

                            {/* Request Number */}
                            <div className="col-md-4">
                                <Form.Group controlId="filterLcNumber">
                                    <Form.Label className="small">Request Number</Form.Label>
                                    <Form.Control
                                        size="sm"
                                        placeholder="Filter by Request Number"
                                        value={filters.lcnumber}
                                        onChange={(e) => setFilters({ ...filters, lcnumber: e.target.value })}
                                    />
                                </Form.Group>
                            </div>

                            {/* Status Dropdown */}
                            <div className="col-md-4">
                                <Form.Group controlId="filterStatus">
                                    <Form.Label className="small">Status</Form.Label>
                                    <Form.Select
                                        size="sm"
                                        value={filters.status}
                                        onChange={(e) => setFilters({ ...filters, status: e.target.value })}
                                    >
                                        <option value="0">All</option>
                                        {statusType.filter(item => item.id !== 2).map(item => (
                                            <option key={item.id} value={item.id}>
                                                {item.name}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </div>

                            {/* Subject Title */}
                            <div className="col-md-4">
                                <Form.Group controlId="filterSubjectTitle">
                                    <Form.Label className="small">Subject Title</Form.Label>
                                    <Form.Control
                                        size="sm"
                                        placeholder="Filter by Subject Title"
                                        value={filters.subjectTitle}
                                        onChange={(e) => setFilters({ ...filters, subjectTitle: e.target.value })}
                                    />
                                </Form.Group>
                            </div>

                            {/* Approval Type */}
                            <div className="col-md-4">
                                <Form.Group controlId="filterLcApproval">
                                    <Form.Label className="small">Approval Type</Form.Label>
                                    <Form.Select
                                        size="sm"
                                        value={filters.lcApproval}
                                        onChange={(e) => setFilters({ ...filters, lcApproval: e.target.value })}
                                    >
                                        <option value="">Select Approval Type</option>
                                        {approvalType.map(item => (
                                            <option key={item.id} value={item.id}>{item.name}</option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </div>

                            {/* Requested By */}
                            <div className="col-md-4">
                                <Form.Group controlId="filterRequestedBy">
                                    <Form.Label className="small">Requested By</Form.Label>
                                    <div className="react-select-container">
                                        <AsyncSelect
                                            id="RequestedBy"
                                            name="RequestedBy"
                                            placeholder="Search and select requester"
                                            defaultOptions
                                            cacheOptions
                                            loadOptions={requestedByOptions}
                                            onChange={(selected) => {
                                                setSelectedRequester(selected);
                                                setFilters({
                                                    ...filters,
                                                    requestedBy: selected ? selected.value : '',
                                                });
                                            }}
                                            isClearable
                                            classNamePrefix="react-select"
                                            styles={{
                                                container: (base) => ({
                                                    ...base,
                                                    width: '100%'
                                                }),
                                                control: (base) => ({
                                                    ...base,
                                                    minHeight: '31px',
                                                    height: '31px',
                                                    fontSize: '0.875rem' // small like Bootstrap's small
                                                }),
                                                valueContainer: (base) => ({
                                                    ...base,
                                                    height: '31px',
                                                    padding: '0 6px',
                                                }),
                                                input: (base) => ({
                                                    ...base,
                                                    margin: '0px',
                                                }),
                                                indicatorsContainer: (base) => ({
                                                    ...base,
                                                    height: '31px',
                                                }),
                                                menu: (provided) => ({
                                                    ...provided,
                                                    zIndex: 9999
                                                })
                                            }}
                                            value={selectedRequester}
                                        />
                                    </div>
                                </Form.Group>
                            </div>


                            {/* Apply Filter Button */}
                            <div className="col-md-4 d-grid align-self-end">
                                <Button variant="primary" size="sm" onClick={handleFilter}>Apply Filters</Button>
                            </div>
                        </div>
                    </Card.Body>
                </Card>



                {/* Table Section */}
                <div className="table-responsive mt-2">
                    <div className="d-flex justify-content-end mb-0">
                        <h6 className="fw-bold text-black">Total Records: {totalRecords}</h6>
                    </div>
                    <Table bordered hover className="align-middle shadow-sm">
                        <thead className="table-light">
                            <tr>
                                <th>Sr No</th>
                                <th>Req Number</th>
                                <th>Subject Line</th>
                                <th>Company</th>
                                <th>Department</th>
                                <th>Type</th>
                                <th>Status</th>
                                <th>Action Date</th>
                                <th>Description View</th>
                                <th>Attachments</th>
                                <th>Requested By</th>
                                <th>Approver History</th>
                                <th>Print View</th>
                            </tr>
                        </thead>
                        <tbody>
                            {reportData.length > 0 ? (
                                reportData.map((item, index) => (
                                    <tr key={index}>
                                        <td>{(currentPage - 1) * pageSize + index + 1}</td>
                                        <td>{item.lcnumber}</td>
                                        <td>{item.title}</td>
                                        <td>{item.companyName}</td>
                                        <td>{item.departmentName}</td>

                                        <td>{item.approvalTypeName}</td>
                                        <td>{item.statusText}
                                            {item.isSendToBank === 1 && (
                                                <>
                                                    <br />
                                                    <button
                                                        className="btn btn-sm"
                                                        style={{
                                                            padding: '2px 5px',
                                                            fontSize: '10px',
                                                            color: 'white',
                                                            backgroundColor: 'green',
                                                            border: 'none',
                                                            borderRadius: '3px',
                                                        }}
                                                        onClick={() => handleSendToBank(item.id)}
                                                    >
                                                        Send to Bank
                                                    </button>
                                                </>
                                            )}
                                        </td>
                                        <td>{item.actionOn}</td>
                                        <td className="text-center">
                                            <Button variant="outline-secondary" size="sm" onClick={() => openDescription(item.description)}>
                                                <FaEye />
                                            </Button>
                                        </td>
                                        <td className="text-center">
                                            {item.attachmentFiles !== "No Attachments" && item.attachmentFiles.split(",").map((fileName, idx) => {
                                                const trimmedFileName = fileName.trim();
                                                const nameParts = trimmedFileName.split("_");
                                                const displayName =
                                                    nameParts.length > 1
                                                        ? nameParts[nameParts.length - 1]
                                                        : trimmedFileName;

                                                const fileExtension = trimmedFileName.split(".").pop().toLowerCase();
                                                const isPdf = fileExtension === "pdf";
                                                const isExcel = ["xls", "xlsx"].includes(fileExtension);
                                                const isImage = ["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(fileExtension);
                                                const shortName =
                                                    displayName.length > 20
                                                        ? displayName.slice(0, 17) + "..."
                                                        : displayName;

                                                return (
                                                    <Button
                                                        key={idx}
                                                        variant="link"
                                                        className="d-flex align-items-center gap-2 p-0"
                                                        title={displayName}
                                                        onClick={async (e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            setLoading(true);
                                                            try {
                                                                await HomeService.actionpreviewAttachment(trimmedFileName, handlePreviewExcel,"ActionAttachment");
                                                            } catch (err) {
                                                                console.error("Error previewing file:", err);
                                                                toast.error("Failed to preview file.");
                                                            } finally {
                                                                setLoading(false);
                                                            }
                                                        }}
                                                    >
                                                        {isPdf && <FaFilePdf color="red" />}
                                                        {isExcel && <FaFileExcel color="green" />}
                                                        {isImage && <FaFileImage color="orange" />}
                                                        {!isPdf && !isExcel && !isImage && <FaDownload />}
                                                        <span>{shortName}</span>
                                                    </Button>
                                                );
                                            })}

                                        </td>

                                        <td>{item.assignedBy}</td>


                                        <td className="text-center">
                                            <Button variant="outline-info" size="sm" onClick={() => handleShowHistory(item)}>
                                                <FaHistory />
                                            </Button>
                                        </td>
                                        <td className="text-center">
                                            <Button
                                                variant="outline-primary"
                                                size="sm"
                                                onClick={() => openDetailsModal(item)}
                                                title="View Details"
                                            >
                                                <FaPrint />
                                            </Button>
                                        </td>

                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="9" className="text-center text-muted">No record found.</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                    <ExcelPreviewModal
                        show={excelshowModal}
                        onHide={() => setexcelShowModal(false)}
                        excelData={excelData}
                        fileName={fileName}
                        fileURL={fileURL}
                    />
                </div>

                {/* Pagination */}
                {totalPages > 1 && (
                    <PaginationComponent
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={setCurrentPage}
                    />
                )}

                {/* Modals */}
                <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" className="small-text-modal" centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Description</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="ck-content" dangerouslySetInnerHTML={{ __html: selectedDescription }} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={showHistoryModal} onHide={() => setShowHistoryModal(false)} centered fullscreen="sm-down" className="small-text-modal">
                    <Modal.Header closeButton>
                        <Modal.Title>History for: {historyItem?.approvalTypeName}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="table-responsive">
                            <table className="table table-bordered table-sm">
                                <thead className="table-light">
                                    <tr>
                                        <th>Sr No</th>
                                        <th>Date</th>
                                        <th>Status</th>
                                        <th>Remark</th>
                                        <th>Action By</th>
                                        <th>Attachment</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {historyData.length > 0 ? (
                                        historyData.map((entry, idx) => (
                                            <tr key={idx}>
                                                <td>{idx + 1}</td>
                                                <td>{entry.actionOn}</td>
                                                <td>{entry.status}</td>
                                                <td>{entry.remark}</td>
                                                <td>{entry.actionBy}</td>
                                                <td>
                                                    {entry.actionAttachments !== "No Attachments" && entry.actionAttachments.split(",").map((fileName, idx) => {
                                                        const trimmedFileName = fileName.trim();
                                                        const nameParts = trimmedFileName.split("_");
                                                        const displayName =
                                                            nameParts.length > 1
                                                                ? nameParts[nameParts.length - 1]
                                                                : trimmedFileName;

                                                        const fileExtension = trimmedFileName.split(".").pop().toLowerCase();
                                                        const isPdf = fileExtension === "pdf";
                                                        const isExcel = ["xls", "xlsx"].includes(fileExtension);
                                                        const isImage = ["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(fileExtension);
                                                        const shortName =
                                                            displayName.length > 20
                                                                ? displayName.slice(0, 17) + "..."
                                                                : displayName;

                                                        return (
                                                            <Button
                                                                key={idx}
                                                                variant="link"
                                                                className="d-flex align-items-center gap-2 p-0"
                                                                title={displayName}
                                                                onClick={async (e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    setLoading(true);
                                                                    try {
                                                                        await HomeService.actionpreviewAttachment(trimmedFileName, handleActionPreviewExcel);
                                                                    } catch (err) {
                                                                        console.error("Error previewing file:", err);
                                                                        toast.error("Failed to preview file.");
                                                                    } finally {
                                                                        setLoading(false);
                                                                    }
                                                                }}
                                                            >
                                                                {isPdf && <FaFilePdf color="red" />}
                                                                {isExcel && <FaFileExcel color="green" />}
                                                                {isImage && <FaFileImage color="orange" />}
                                                                {!isPdf && !isExcel && !isImage && <FaDownload />}
                                                                <span>{shortName}</span>
                                                            </Button>
                                                        );
                                                    })}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="6" className="text-center">No history found.</td>
                                        </tr>
                                    )}
                                </tbody>
                                {/* Excel ActionPreview Modal */}

                                <ActionExcelPreviewModal
                                    show={actionexcelshowModal}
                                    onHide={() => {
                                        setactionexcelShowModal(false);
                                        setactionExcelData([]);
                                        setactionFileName("");
                                        setactionFileURL("");
                                    }}
                                    excelData={actionexcelData}
                                    fileName={actionfileName}
                                    fileURL={actionfileURL}
                                />
                            </table>
                        </div>
                    </Modal.Body>
                </Modal>




                <Modal
                    show={showDetailsModal}
                    onHide={() => setShowDetailsModal(false)}
                    centered
                    dialogClassName="rounded-4 custom-preview-modal"
                >
                    {/* Modal Header */}
                    <Modal.Header
                        closeButton
                        className="border-bottom-0"
                        style={{
                            paddingTop: '1rem',
                            paddingBottom: '0.5rem',
                            paddingLeft: '1rem',
                            paddingRight: '1rem',
                        }}
                    />

                    {/* Modal Body */}
                    <Modal.Body style={{ backgroundColor: '#f8f9fa', maxHeight: '70vh', overflowY: 'auto' }}>
                        <div id="printable-details">
                            {selectedDetails ? (
                                <div className="shadow-sm rounded-3 p-3 bg-white" style={{ border: '1px solid #dee2e6' }}>
                                    {/* Title and Logo Row */}
                                    <div
                                        className="position-relative mb-3"
                                        style={{
                                            borderBottom: '2px solid #0d6efd',
                                            paddingBottom: '0.4rem',
                                            height: '50px',
                                        }}
                                    >
                                        <h2
                                            className="fw-bold text-primary mb-0 position-absolute top-50 start-50 translate-middle"
                                            style={{
                                                fontSize: '1.2rem',
                                                letterSpacing: '0.5px',
                                                textTransform: 'uppercase',
                                                margin: 0,
                                                whiteSpace: 'nowrap',
                                            }}
                                        >
                                            {selectedDetails.approvalTypeName}
                                        </h2>
                                        <div className="position-absolute top-50 end-0 translate-middle-y pe-2">
                                            <img
                                                src={logo}
                                                alt="Logo"
                                                style={{
                                                    maxWidth: '100px',
                                                    height: 'auto',
                                                    objectFit: 'contain',
                                                }}
                                            />
                                        </div>
                                    </div>

                                    {/* Info Grid */}
                                    <div className="mb-3" style={{ margin: 'auto' }}>
                                        {[
                                            [
                                                { label: 'Request Number', value: selectedDetails.lcnumber },
                                                { label: 'Company Name', value: selectedDetails.companyName },
                                                { label: 'Department', value: selectedDetails.departmentName },
                                            ],
                                            [
                                                { label: 'Current Status', value: selectedDetails.statusText },
                                                { label: 'Assigned By', value: selectedDetails.assignedBy },
                                                { label: 'Requested Date', value: selectedDetails.requestedOn },
                                            ],
                                        ].map((row, idx) => (
                                            <div
                                                key={idx}
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    marginBottom: '0.5rem',
                                                    borderBottom: '1px solid #e0e0e0',
                                                    paddingBottom: '6px',
                                                }}
                                            >
                                                {row.map((item, i) => (
                                                    <div
                                                        key={i}
                                                        style={{
                                                            flex: '1 1 30%',
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            textAlign: i === 0 ? 'left' : i === 1 ? 'center' : 'right',
                                                        }}
                                                    >
                                                        <span
                                                            style={{
                                                                fontWeight: '600',
                                                                color: '#495057',
                                                                fontSize: '0.75rem',
                                                                marginBottom: '2px',
                                                                textTransform: 'uppercase',
                                                                letterSpacing: '0.05em',
                                                            }}
                                                        >
                                                            {item.label}
                                                        </span>
                                                        <span
                                                            style={{
                                                                fontWeight: '700',
                                                                fontSize: '0.75rem',
                                                                color: '#212529',
                                                                wordBreak: 'break-word',
                                                            }}
                                                        >
                                                            {item.value || '-'}
                                                        </span>
                                                    </div>
                                                ))}
                                            </div>
                                        ))}
                                    </div>

                                    {/* Description */}
                                    <div className="mb-3">
                                        <h6 className="fw-semibold mb-2 text-secondary">
                                            Description: {selectedDetails.title}
                                        </h6>
                                        <div
                                            className="ck-content border rounded p-2"
                                            style={{
                                                backgroundColor: '#fff',
                                                fontSize: '0.75rem',
                                                lineHeight: '1.5',
                                                wordBreak: 'break-word',
                                            }}
                                            dangerouslySetInnerHTML={{ __html: selectedDetails.description }}
                                        />
                                    </div>

                                    {/* History Comments */}
                                    <div className="mb-3">
                                        <h6 className="fw-semibold mb-2 text-secondary">History:</h6>
                                        <div className="border rounded p-2 bg-white">
                                            {(selectedDetails?.approvalCommentsList || []).map((approvercommentStr, idx) => {
                                                const match = approvercommentStr.match(/^(.*?)\s*\((.*?)\)$/);
                                                const name = match?.[1] || approvercommentStr;
                                                const comment = match?.[2] || '';
                                                return (
                                                    <div
                                                        key={idx}
                                                        style={{
                                                            borderBottom: '1px solid #e0e0e0',
                                                            paddingBottom: '0.5rem',
                                                            marginBottom: '0.5rem',
                                                        }}
                                                    >
                                                        <div style={{ fontWeight: '700', color: '#212529', fontSize: '0.75rem' }}>
                                                            {name}
                                                        </div>
                                                        <div
                                                            style={{
                                                                fontWeight: '500',
                                                                color: '#495057',
                                                                fontSize: '0.75rem',
                                                                marginTop: '0.25rem',
                                                            }}
                                                        >
                                                            {comment}
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>

                                    {/* Approvers */}
                                    <div className="mb-3">
                                        <h6 className="fw-semibold mb-2 text-secondary">Approvers:</h6>
                                        <div className="border rounded p-2 bg-white">
                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
                                                {(selectedDetails?.approverNameList || []).map((approverStr, idx) => {
                                                    const match = approverStr.match(/^(.*?)\s*\((.*?)\)$/);
                                                    const name = match?.[1] || approverStr;
                                                    const approveDate = match?.[2] || '';
                                                    return (
                                                        <div
                                                            key={idx}
                                                            style={{
                                                                flex: '1 0 45%',
                                                                minWidth: '120px',
                                                                borderBottom: '1px solid #e0e0e0',
                                                                paddingBottom: '0.5rem',
                                                            }}
                                                        >
                                                            <div style={{ fontWeight: '700', color: '#212529', fontSize: '0.75rem' }}>
                                                                {name}
                                                            </div>
                                                            <div
                                                                style={{
                                                                    fontWeight: '500',
                                                                    color: '#495057',
                                                                    fontSize: '0.75rem',
                                                                    marginTop: '0.25rem',
                                                                }}
                                                            >
                                                                {approveDate}
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>

                                    <span style={{ fontSize: '0.7rem' }}>
                                        This document is digitally signed and does not require a physical signature.
                                    </span>
                                </div>
                            ) : (
                                <p className="text-center text-muted">No details available.</p>
                            )}
                        </div>
                    </Modal.Body>

                    {/* Modal Footer */}
                    <Modal.Footer
                        className="border-top-0"
                        style={{
                            paddingTop: '0.5rem',
                            paddingBottom: '0.5rem',
                            paddingLeft: '1rem',
                            paddingRight: '1rem',
                        }}
                    >
                        <Button variant="outline-secondary" onClick={() => setShowDetailsModal(false)}>
                            Close
                        </Button>
                        <Button variant="primary" onClick={handlePrint}>
                            Print
                        </Button>
                    </Modal.Footer>
                </Modal>



            </div>
        </div>
    );
};

export default StatusReport;
